<template>
	<div v-if="is_show" class="cmbc_main width_100">
		<van-sticky>
			<div class="cmbc_main_head width_100">
				<div class="cmbc_main_head_title width_100 width_100 text_align_center font_size_34 color_333333 font_weight_600">场馆列表</div>
				<div class="cmbc_main_head_block width_100 display_between_center display_center_center bg_FFFFFF">
					<div @click="switchCity()"
						class="cmbc_main_head_block_left text_ellipsis2 width_fit display_center_center color_666666 font_size_26">
						{{city_name?city_name:'请选择'}}
						<van-icon name="arrow-down" />
					</div>
					<van-field
					    v-model="key_words"
					    label=""
					    placeholder="请输入"
						@input="getPageListBefore"
					  />
					  <van-icon v-if="key_words.length>0" @click="removeKeyword" name="cross" />
					<!-- <input v-model="key_words" @blur="getPageListBefore()" class="cmbc_main_head_block_right font_size_26" type="text" placeholder="请输入"> -->
				</div>
			</div>
		</van-sticky>
		<div v-if="is_load">
			<div v-if="total_list.length>0" class="cmbc_main_list">
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage">
					<div v-for="(item,index) in total_list" :key="index"
						class="cmbc_main_list_block width_100 border_radius_16 bg_FFFFFF" @click="nextPage2(item)">
						<div class="cmbc_main_list_block_title width_100 font_size_28 color_333333">{{item.venueName}}</div>
						<div class="cmbc_main_list_block_address width_100 font_size_24 color_999999">
							详细地址：{{item.address}}</div>
					</div>
				</van-list>
			</div>
			<div v-else>
				<empty />
			</div>
		</div>

		<van-popup v-model="city_show" position="bottom" closeable
			style="border-radius: 8px 8px 0 0;background-color: #F6F7F9;">
			<div class="cmbc_pop width_100">
				<div class="cmbc_pop_title width_100 text_align_center font_size_34 color_333333 font_weight_600">请选择</div>
				<div class="cmbc_pop_search width_100 display_center_center bg_FFFFFF border_radius_16">
					<van-field
					    v-model="filter_city"
					    placeholder="请输入"
						@input="filterCity"
					  />
					  <van-icon v-if="filter_city.length>0" @click="removeFilterCity()" name="cross" />
				</div>
				<div v-if="filter_city.length==0" class="cmbc_pop_list width_100 border_radius_16 bg_FFFFFF">
					<van-index-bar :index-list="indexList" :sticky="false" highlight-color="#F77F28">
						<div v-for="(item1,index1) in az_list" :key="'index'+index1">
							<van-index-anchor :index="item1.lettter"></van-index-anchor>
							<div v-for="(item2,index2) in item1.list" :key="'index'+index2" class="cmbc_pop_list_item">
								<div class="cmbc_pop_list_block width_100 color_666666" @click="selectCity(item2)">{{item2.city}}</div>
							</div>
							<!-- <van-index-anchor :index="'item1'+index1">
								<div class="cmbc_pop_list_title width_100 color_666666">{{item1.lettter}}</div>
							</van-index-anchor>
							<div v-for="(item2,index2) in item1.list" :key="'index'+index2" class="cmbc_pop_list_item">
								<div class="cmbc_pop_list_block width_100 color_666666" @click="selectCity(item2)">{{item2.city}}</div>
							</div> -->
						</div>
					</van-index-bar>
				</div>
				<div v-else class="cmbc_pop_list width_100 border_radius_16 bg_FFFFFF">
					<div v-for="(item2,index2) in filter_city_list" :key="'index'+index2" class="cmbc_pop_list_item">
						<div class="cmbc_pop_list_block width_100 color_666666" @click="selectCity2(item2)">{{item2.city}}</div>
					</div>
				</div>
			</div>
		</van-popup>

	</div>
</template>
<script>
	import {
		datePrintStr
	} from "../lib/utils.js"
	import empty from '../components/empty.vue';
	import {
		getCitysFromTemplateV2,getVenuesFromTemplateV2V2,getVenueDetailFromTemplateV2V2
	} from '../api/api.js'
	export default {
		components: {
			empty
		},
		data() {
			return {
				is_show:false,
				city_show: false,
				is_load:false,

				key_words: '',

				loading: true, //是否处于加载状态，加载过程中不触发load事件
				finished: false, //是否已加载完成，加载完成后不再触发load事件

				page: 1,
				page_size: 20,
				total_list: [],
				city_id:1101,
				city_name:'北京市',
				
				az_list:[],
				indexList: [],
				
				filter_city:'',
				filter_city_list:[],
				
				
				sportType:'RC008'
				
			}
		},
		mounted() {
			this.is_show=true
			this.getCity()
			return
			// console.log(this.$route.query.sportType);
			if(this.$route.query.sportType){
				var st=this.$route.query.sportType
				if(st=='RC001'||st=='RC002'||st=='RC006'||st=='RC008'){
					this.is_show=true
					this.getCity()
				}else{
					this.$toast('链接异常');
				}
			}else{
				this.$toast('链接异常');
			}
			// this.getPageList()
			// index_city
			
		},
		methods: {
			removeFilterCity(){
				this.filter_city=''
			},
			filterCity(e){
				// console.log(e);
				if(e.length==0){return}
				var filter_city_list=[]
				this.az_list.map((item_1)=>{
					item_1.list.map((item_2)=>{
						if(item_2.city.indexOf(e)>=0){
							filter_city_list.push(item_2)
						}
					})
				})
				// console.log(filter_city_list);
				this.filter_city_list=filter_city_list
			},
			async getCity(){
				this.$loading('正在加载中...');
				var $this = this
				var param = {
					sport_type:this.sportType
				}
				try {
					var res=await getCitysFromTemplateV2(param)
					var index_list=[]
					res.data.map((item,index)=>{
						index_list.push(item.letter)
					})
					index_list=Array.from(new Set(index_list))
					// console.log(index_list);
					this.indexList=index_list
					var az_list=[]
					index_list.map((item)=>{
						var params={
							lettter:item,
							list:[]
						}
						az_list.push(params)
					})
					// console.log('az_list',az_list);
					az_list.map((item_1)=>{
						res.data.map((item_2)=>{
							if(item_1.lettter==item_2.letter){
								item_1.list.push(item_2)
							}
						})
					})
					console.log(az_list);
					$this.az_list=az_list
					$this.$loading.close();
					$this.getPageListBefore()
				} catch (error) {
					//TODO handle the exception
				}
				return
				var qs = require('qs');
				let url = this.api.userApi.index_city
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res);
						var index_list=[]
						res.data.map((item,index)=>{
							index_list.push(item.letter)
						})
						index_list=Array.from(new Set(index_list))
						// console.log(index_list);
						this.indexList=index_list
						var az_list=[]
						index_list.map((item)=>{
							var params={
								lettter:item,
								list:[]
							}
							az_list.push(params)
						})
						// console.log('az_list',az_list);
						az_list.map((item_1)=>{
							res.data.map((item_2)=>{
								if(item_1.lettter==item_2.letter){
									item_1.list.push(item_2)
								}
							})
						})
						console.log(az_list);
						$this.az_list=az_list
						$this.$loading.close();
						$this.getPageListBefore()
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.data.msg?error.data.msg:error.msg);
					})
			},
			switchCity() {
				this.city_show = !this.city_show
			},
			selectCity(e){
				// // console.log(e);
				this.city_id=e.cityId
				this.city_name=e.city
				this.switchCity()
				this.getPageListBefore()
			},
			selectCity2(e){
				this.city_id=e.cityId
				this.city_name=e.city
				this.switchCity()
				this.getPageListBefore()
				this.filter_city=''
			},
			removeKeyword(){
				this.key_words=''
				this.getPageListBefore()
			},
			getPageListBefore(){
				this.$loading('正在加载中...');
				this.page=1
				this.total_list=[]
				this.loading=true
				this.finished=false
				this.is_load=false
				this.getPageList()
			},
			async getPageList(){
				var $this = this
				var param = {
					sport_type:this.sportType,
					
					city_id:this.city_id,
					keyword:this.key_words,
					page:this.page,
					page_size:this.page_size
				}
				
				try {
					var res=await getVenuesFromTemplateV2V2(param)
					var list = res.data
					if ($this.page == 1) {
						$this.total_list = list
						$this.loading = false
						$this.finished = $this.total_list.length < $this.page_size ? true : false
						$this.is_load=true
					} else {
						if(list.length==0){
							// $this.total_list = [...$this.total_list, ...list]
							$this.loading = false
							$this.finished =true
							$this.is_load=true
						}else{
						$this.total_list = [...$this.total_list, ...list]
						$this.loading = false
						$this.finished = $this.total_list.length < $this.page_size ? true : false
						$this.is_load=true	
						}
						
					}
					$this.$loading.close();
				} catch (error) {
					//TODO handle the exception
				}
				return
				var qs = require('qs');
				let url = this.api.userApi.getVenuesFromTemplate
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res);
						var list = res.data
						if ($this.page == 1) {
							$this.total_list = list
							$this.loading = false
							$this.finished = $this.total_list.length < $this.page_size ? true : false
							$this.is_load=true
						} else {
							if(list.length==0){
								// $this.total_list = [...$this.total_list, ...list]
								$this.loading = false
								$this.finished =true
								$this.is_load=true
							}else{
							$this.total_list = [...$this.total_list, ...list]
							$this.loading = false
							$this.finished = $this.total_list.length < $this.page_size ? true : false
							$this.is_load=true	
							}
							
						}
						$this.$loading.close();
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.data.msg?error.data.msg:error.msg);
					})
					
					
			},
			nextPage() {
				// console.log('加载下一页');
				if (this.finished) {
					return
				}

				this.loading = true
				this.page = this.page + 1
				this.getPageList()
			},
			nextPage2(e){
				console.log(e);
				var params={
					service_id:e.serviceId,
					sport_type:this.sportType,
				}
				this.$router.push({
					name:'cmbc_cr_main_detail',
					params:params
				})
			}
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;

	.cmbc_main {
		min-height: 100vh;
		background-color: #F6F7F9;
	}

	.cmbc_main_head {
		padding: 20*@vm_base;
		background-color: #F6F7F9;
		.cmbc_main_head_title{
			padding: 20*@vm_base;
		}

		.cmbc_main_head_block {
			// border: 1*@vm_base solid red;
			border-radius: 50*@vm_base;
			padding: 0 20*@vm_base;
			overflow: hidden;

			.cmbc_main_head_block_left {
				height: 80*@vm_base;
				padding-right: 20*@vm_base;
				border-right: 1*@vm_base solid #dcdcdc;
			}

			.cmbc_main_head_block_right {
				width: 100%;
				border: none;
				height: 80*@vm_base;
				padding: 0 20*@vm_base;
			}
		}
	}

	.cmbc_main_list {
		padding: 0 20*@vm_base 30*@vm_base 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);

		.cmbc_main_list_block {
			padding: 20*@vm_base;
			margin-bottom: 20*@vm_base;

			.cmbc_main_list_block_title {
				line-height: 1.5;
				padding-bottom: 4*@vm_base;
			}

			.cmbc_main_list_block_address {
				line-height: 1.5;
			}
		}

		.cmbc_main_list_block:last-child {
			margin-bottom: 0;
		}
	}

	.cmbc_pop {
		padding: 0 20*@vm_base 20*@vm_base 20*@vm_base;

		.cmbc_pop_title {
			padding: 40*@vm_base;
		}
		.cmbc_pop_search{
			margin-bottom: 20*@vm_base;
			padding: 0 20*@vm_base 0 0;
		}

		.cmbc_pop_list {
			height: 80vh;
			padding:0 20*@vm_base;
			overflow: hidden;
			overflow-y: auto;
		}
		.cmbc_pop_list_title{
			padding: 20*@vm_base 0;
		}
		.cmbc_pop_list_item{
			padding: 0 16px;
		}
		.cmbc_pop_list_block{
			padding: 20*@vm_base 0;
			border-bottom: 1*@vm_base solid #d9d9d9;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/main.vue